module.exports = __webpack_public_path__ + "static/media/sliderImage2.99a2e203.png";